'use client';

import { useEffect } from 'react';
import { useAccount, useConnect, useDisconnect } from 'wagmi';

interface WagmiInnerConsumerProps {
  onAddress: (addr: string | undefined) => void;
  onConnected: (connected: boolean, settled: boolean) => void;
  onActions: (actions: { connect: any; connectors: any[]; disconnect: any }) => void;
}

export default function WagmiInnerConsumer({ onAddress, onConnected, onActions }: WagmiInnerConsumerProps) {
  const { address, isConnected, status } = useAccount();
  const { connect, connectors } = useConnect();
  const { disconnect } = useDisconnect();

  useEffect(() => {
    onAddress(address);
    // "settled" is false while wagmi is still reconnecting/connecting, so the auth provider
    // doesn't prematurely decide the user is logged out (which would bounce them to login).
    const settled = status !== 'reconnecting' && status !== 'connecting';
    onConnected(isConnected, settled);
  }, [address, isConnected, status]);

  useEffect(() => {
    onActions({ connect, connectors: [...connectors], disconnect });
  }, [connect, connectors, disconnect]);

  return null;
}
